module.exports = __webpack_public_path__ + "img/NMI-Logo-Purple_Text.5cac67c6.jpg";